/* unplugin-vue-components disabled */import script from "./GameHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHeader.vue?vue&type=script&setup=true&lang=js"

import "./GameHeader.vue?vue&type=style&index=0&id=94e9988e&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94e9988e"]])

export default __exports__